import _default from './TextArea';
export { _default as default };